typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let e, t;
  const o = new Promise((n, r) => {
    e = n, t = r;
  });
  return { resolve: e, reject: t, promise: o };
});
function u(e) {
  const t = document.cookie.match(`\\b${e}=([^;]*)\\b`);
  return t ? t[1] : void 0;
}
function a() {
  const e = "testData";
  try {
    const { localStorage: t } = window;
    t.setItem(e, e), t.getItem(e), t.removeItem(e);
  } catch {
    return !1;
  }
  return !0;
}
function m(e) {
  return e != null;
}
function d(e) {
  return e == null;
}
const i = /\/+$/, l = /^\/+/;
function f({ hostname: e, port: t, pathname: o, protocol: n }, r) {
  const c = s(o, r);
  return `${n}//${e}${t ? `:${t}` : ""}/${c}`;
}
function s(e, t) {
  return e = e.replace(i, "").replace(l, ""), t = t.replace(i, "").replace(l, ""), e.length === 0 ? t : `${e}/${t}`;
}
const p = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
export {
  f as buildHttpUri,
  u as getCookie,
  p as isLocalhost,
  d as isNullOrUndefined,
  a as localStorageAvailable,
  s as makePath,
  m as notNullOrUndefined
};
